import { type Common } from './common.js';
import { type NoteFieldWithConfig } from './models/note/field.js';
import { Kind, type Note, type Reason } from './models/note.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findByEncounterId(encounterId: string, includeDeleted = false): Promise<Note[]> {
    const url = this.common.constructPath(`/note`, {
      encounterId,
      includeDeleted,
    });
    const { notes } = await this.common.getJSON(url);
    return notes;
  }

  async findOneNotableByEncounterId(
    encounterId: string,
    includeDeleted = false
  ): Promise<Note | undefined> {
    const notes = await this.findByEncounterId(encounterId, includeDeleted);
    return notes.find((note) => note.kind === Kind.Notable);
  }

  async findOneById(id: string): Promise<Note> {
    const url = this.common.constructPath(`/note/${id}`);
    const { note } = await this.common.getJSON(url);
    return note;
  }

  async updateReviewFields(
    id: string,
    values: {
      contentNeedsReviewReasons?: Reason[];
      contentNeedsReviewComment?: string;
    }
  ): Promise<Note> {
    const url = this.common.constructPath(`/note/${id}`);
    return await this.common.putJSON(url, { ...values });
  }

  async findFieldsByNoteId(noteId: string): Promise<NoteFieldWithConfig[]> {
    const url = this.common.constructPath(`/note/${noteId}/fields`);
    const { fields } = await this.common.getJSON(url);
    return fields;
  }

  async updateField(id: string, value: string): Promise<NoteFieldWithConfig> {
    const url = this.common.constructPath(`/note/field/${id}`);
    return await this.common.putJSON(url, { value });
  }

  async getFormattedNote(noteId: string): Promise<{ formattedNote: string }> {
    const url = this.common.constructPath(`/note/${noteId}/formatted`);
    return await this.common.getJSON(url);
  }
}
